/* @flow */

import cookies from 'js-cookie';
import { CHAVE_TOKEN } from '../utils/constants';

const getTokenApi = (): string => cookies.get(CHAVE_TOKEN) || '';

export default getTokenApi;
